// Centralized API base URL for all frontend requests
// Update this to your server IP/hostname in production
export const API_BASE_URL = 'https://sarv.zimg.co/api';


